import Vue from 'vue'
import Router from 'vue-router'

//组件模块
import index from './components/index'
import panorama from './components/panorama'
import about from './components/about'
import newsDetail from './components/newsDetail'
import exDetail from './components/exDetail'
import tList from './components/tList'
import proDetail from './components/proDetail'



Vue.use(Router)
export default new Router({
  //mode: 'history',
  routes: [
    { path: '/', name: 'index', component: index ,meta: {title: '第十三届全国美术作品展览'}},
    { path: '/panorama', name: 'panorama', component: panorama,meta: {title: '第十三届全国美术作品展览'}},
    { path: '/proDetail', name: 'proDetail', component: proDetail,meta: {title: '第十三届全国美术作品展览'}},
    { path: '/about', name: 'about', component: about ,meta: {title: '第十三届全国美术作品展览'} },
    { path: '/newsDetail', name: 'newsDetail', component: newsDetail ,meta: {title: '第十三届全国美术作品展览'} },
    { path: '/exDetail', name: 'exDetail', component: exDetail ,meta: {title: '第十三届全国美术作品展览'} },
    { path: '/tList', name: 'tList', component: tList ,meta: {title: '第十三届全国美术作品展览'}}
  ],
  scrollBehavior (to, from, savedPosition) {
       if (savedPosition) {
        return savedPosition
       } else {
        return { x: 0, y: 0 }
       }
   }
})
var reg = new RegExp("code=([^&]+)");